import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useState } from 'react';
import type { HookMap } from '@toast-ui/editor';
import { pipe } from 'fp-ts/function';
import { ApplicationState, Option as OptionType } from '@mews-commander/types';
import { AppClockServiceProps, withAppClockService } from '@mews/framework';
import { uploadTaskImage } from '@mews-commander/legacy-entities/src/actions/tasks';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import TasksForm from '../components/TasksForm';
import { getCurrentDepartmentsOption, getTaskFormInitialValues } from '../selectors';
import { createTask } from '../actions/actions';
import { FormValues } from '../types';

interface OwnProps {
    form: string;
    serviceOrderId?: string;
    scope: string;
}
interface StateProps {
    departments: Array<OptionType>;
    initialValues: FormValues;
}

const TaskAddForm = TasksForm({ updateTask: false });
const TaskAddFormConnected = (props: OwnProps & StateProps) => {
    const dispatch = useCommanderThunkDispatch();
    const [imageIds, setImageIds] = useState<string[]>([]);

    const markdownEditorHooks: HookMap = {
        addImageBlobHook: async (blob, callback) => {
            const {
                value: { imageId, url },
            } = await dispatch(uploadTaskImage(blob));
            callback(url);
            setImageIds((state) => [...state, imageId]);
        },
    };
    const onSubmit = (formData: FormValues) => dispatch(createTask(formData, imageIds.length > 0 ? imageIds : null));
    return <TaskAddForm {...props} markdownEditorHooks={markdownEditorHooks} onSubmit={onSubmit} />;
};
export default pipe(
    TaskAddFormConnected,
    connect<StateProps, {}, OwnProps & AppClockServiceProps, ApplicationState>(
        createStructuredSelector({
            departments: getCurrentDepartmentsOption,
            initialValues: getTaskFormInitialValues,
        })
    ),
    withAppClockService
);
